/**
 * @doc Editor
 */
export var MediaType;
(function (MediaType) {
    MediaType["Image"] = "IMAGE";
    MediaType["Video"] = "VIDEO";
    MediaType["Document"] = "DOCUMENT";
})(MediaType || (MediaType = {}));
//# sourceMappingURL=media.js.map